import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const updateMetaTag = (selector, attribute, value) => {
  let el = document.querySelector(selector);
  if (!el && value) {
    el = document.createElement(selector.includes('link') ? 'link' : 'meta');
    
    // Parse selector to reconstruct missing element (e.g. 'meta[property="og:title"]')
    const propMatch = selector.match(/\[(name|property)="([^"]+)"\]/);
    if (propMatch) {
      el.setAttribute(propMatch[1], propMatch[2]);
    } else if (selector.includes('link[rel=')) {
      el.setAttribute('rel', 'canonical');
    }
    
    document.head.appendChild(el);
  }
  if (el) {
    if (value) el.setAttribute(attribute, value);
    else el.remove();
  }
};

export default function CanonicalUrl() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Normalize path: Remove trailing slash unless it's just the root "/"
    const normalizedPath = pathname.length > 1 && pathname.endsWith('/') 
      ? pathname.slice(0, -1) 
      : pathname;
      
    // Ensure lowercase to prevent duplicate content issues with mixed-case URLs
    const lowerPath = normalizedPath.toLowerCase();
    const url = `https://uploadtourl.com${lowerPath === '/' ? '' : lowerPath}`;

    // Update canonical link
    updateMetaTag('link[rel="canonical"]', 'href', url);
    // Update og:url
    updateMetaTag('meta[property="og:url"]', 'content', url);
  }, [pathname]);

  return null;
}
